import script from "./UsersManager.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersManager.vue?vue&type=script&setup=true&lang=js"

import "./UsersManager.vue?vue&type=style&index=0&id=3c86eb7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c86eb7d"]])

export default __exports__